import debounce from '../../helpers/debounce'
import isVisibleOnViewport from '../../helpers/is-visible-on-viewport'

class Analytics {
  constructor(target, options) {
    this.target = target
    this.targetLinks = target.tagName === 'A' ? [target] : target.querySelectorAll('a')
    this._resourceName = options.resourceName
    this._apiPath = options.apiPath
    this.customParams = options.params
    this._viewed = false
    this._sending = false
  }

  get apiPath () {
    return this._apiPath
  }

  set apiPath (newValue) {
    this._apiPath = newValue
  }

  get resourceName() {
    return this._resourceName
  }

  set resourceName (newValue) {
    this._resourceName = newValue
  }

  get viewed () {
    return this._viewed
  }

  set viewed (newValue) {
    this._viewed = newValue
  }

  get sending () {
    return this._sending
  }

  set sending (newValue) {
    this._sending = newValue
  }

  get visible () {
    return isVisibleOnViewport(this.target)
  }

  _setHeaders() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    return new Headers({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRF-TOKEN': csrfToken
    })
  }

  _formattedParams(data) {
    const params = new URLSearchParams()

    for (let key in data) {
      params.append(`${this.resourceName}[${key}]`, data[key])
    }

    return params
  }

  async create(data) {
    const headers = this._setHeaders()
    const params = this._formattedParams(data)
    const options = {
      headers,
      body: params,
      method: 'POST'
    }

    try {
      const response = await fetch(this.apiPath, options)

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      this.viewed = response.ok
    } catch(error) {
      console.error(error)
    } finally {
      this.sending = false
    }
  }

  saveUniqueView () {
    if (this.viewed || !this.visible || this.sending) return

    this.sending = true

    this.targetLinks.forEach(async ({ href: url }) => {
      const data = { url, ...this.customParams, event: 'view' }

      this.create(data)
    })
  }

  saveLinkClick (event) {
    const url = event.target.href
    const data = { url, ...this.customParams, event: 'click' }

    this.create(data)
  }

  init () {
    if (!this.target) return

    this.saveUniqueView()

    this.targetLinks.forEach(link => {
      link.addEventListener('click', this.saveLinkClick.bind(this))
    })

    document.addEventListener('scroll', debounce(this.saveUniqueView.bind(this), 3000))
    window.addEventListener('resize', debounce(this.saveUniqueView.bind(this), 3000))
  }
}

export default Analytics